"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var reminders_html_1 = __importDefault(require("./reminders.html"));
var reminders_controller_1 = __importDefault(require("./reminders.controller"));
function config($stateProvider, $urlRouterProvider) {
    $stateProvider.state("drivecoach.admin.reminders", {
        url: "/reminders",
        controller: "AdminRemindersController",
        controllerAs: "vm",
        template: reminders_html_1.default,
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider"];
exports.default = angular_1.default
    .module("drivecoach.admin.reminders", [])
    .config(config)
    .controller("AdminRemindersController", reminders_controller_1.default);
